module.exports = __webpack_public_path__ + "img/ShouYao.4ead6efe.svg";